export const CUSTOM_LOCATIONS = 'CUSTOM_LOCATIONS';
export type CustomLocations = typeof CUSTOM_LOCATIONS;
